import { z } from 'zod';
import { baseResponseSchema, createResponseSchema } from '../../../schemas/repository.schemas';
import { notificationInfoSchema } from '../../../schemas/notification.schemas';

export const notificationListResponseSchema = createResponseSchema(z.array(notificationInfoSchema));
export type NotificationListResponseSchemaType = z.infer<typeof notificationListResponseSchema>;

export const unreadCountResponseSchema = createResponseSchema(z.number());
export type UnreadCountResponseSchemaType = z.infer<typeof unreadCountResponseSchema>;

export const voidResponseSchema = baseResponseSchema;
export type VoidResponseSchemaType = z.infer<typeof voidResponseSchema>;
